import React, {
  createContext,
  FunctionComponent,
  useContext,
  useState,
} from 'react';
import { To, useNavigate, useParams } from 'react-router-dom';
import { PageStepperContext } from './formBuilder/pageStepperContext';

export interface IError {
  text?: string;
  header?: string;
  status?: string;
}

interface GlobalErrorProviderProps {
  error?: IError;
  setError: (error: IError) => void;
  errorPageVisited: boolean;
  setErrorPageVisited: (flag: boolean) => void;
}

export const GlobalErrorStateContext = createContext<GlobalErrorProviderProps>(
  {} as GlobalErrorProviderProps
);

const GlobalErrorProvider: FunctionComponent = ({ children }) => {
  const [error, setError] = useState<IError>();
  const [errorPageVisited, setErrorPageVisited] = useState(false);

  return (
    <GlobalErrorStateContext.Provider
      value={{
        error,
        setError,
        errorPageVisited,
        setErrorPageVisited,
      }}
    >
      {children}
    </GlobalErrorStateContext.Provider>
  );
};

export const useErrorPage = () => {
  const { setError, setErrorPageVisited, errorPageVisited } = useContext(
    GlobalErrorStateContext
  );
  const navigate = useNavigate();
  const { project } = useParams();
  const { setStep } = useContext(PageStepperContext);
  const handleError = (error: IError) => {
    setError(error);
    setErrorPageVisited(true);
    console.error(
      `Error status: ${error.status}, header: ${error.header}, text: ${error.text}`
    );
    navigate(('/' + project + '/error') as To, {
      state: { statusCode: error.status },
    });
    setStep(null);
  };
  return { handleError, errorPageVisited };
};

export default GlobalErrorProvider;
